import type { LoginProviderProps } from './types';

import { createContext } from 'react';

import { LoginScreenEnum } from './enums';

export const LoginContext = createContext<LoginProviderProps>({
  hasOtpRetryAttempts: false,
  isOtpCodeInvalid: false,
  isSubmittingLogin: false,
  isVerifyingOtp: false,
  nextOtpResendableRemainSeconds: null,
  onChangeOtp: async () => {},
  onResendOtp: () => {},
  otpCode: [undefined, undefined, undefined, undefined],
  recaptchaRef: { current: null },
  screen: LoginScreenEnum.login,
  session: null,
  setScreen: () => {},
  submitLogin: () => {},
});
